export default "__VITE_ASSET__DtbSJ3FH__"